<template>
  <div>
    TICKET DETAIL
  </div>
</template>
